import React, {Component} from 'react';
import Modal from 'react-modal';
import withAuthorization from "../auth/withAuthorization";
import {Link, withRouter} from "react-router-dom";
import {deleteGame, fetchGame } from "../../actions";
import { connect} from "react-redux";
import {  WizardHeader} from "../common_page_elements";

import '../../global.css';
import AddCluesComponent from "../clues/MainClueList";
import {compose} from "recompose";
import {ConfirmDelete, MessageDialog} from "../huntcomponents/dialogs";


class WizardClues extends Component {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirmIsOpen: false,
            huntCompletedIsOpen: false
        };

        this.onNext = this.onNext.bind(this);
        this.moveOn = this.moveOn.bind(this);
        this.delete = this.delete.bind(this);
        this.openDeleteModal = this.openDeleteModal.bind(this);
        this.closeDeleteModal = this.closeDeleteModal.bind(this);
        this.openHuntCompletedModal = this.openHuntCompletedModal.bind(this);
        this.closeHuntCompletedModal = this.openHuntCompletedModal.bind(this);
    }

    componentDidMount () {
        window.scrollTo(0, 0)
    }

    openDeleteModal(index) {
        this.setState({deleteConfirmIsOpen: true, indexSelected: index});
    }

    closeDeleteModal() {
        this.setState({deleteConfirmIsOpen: false, indexSelected: -1}
        );
    }

    openHuntCompletedModal() {
        this.setState({huntCompletedIsOpen: true});
    }

    closeHuntCompletedModal() {
        this.setState({huntCompletedIsOpen: false}
        );
    }

    delete() {
        const {id} = this.props.match.params;
        const game = this.props.games[id];

        const isPublic = game.isPublic;

        this.props.deleteGame(id, isPublic, () => {
            this.props.history.push('/games');
        });
    }

    onNext() {
        // validate?
        const clues = this.game().clues;
        if (!clues || clues.length < 1) {
            alert("You should enter at least one clue to get started.");
            return;
        }

        this.openHuntCompletedModal();
    }

    moveOn() {
        this.closeHuntCompletedModal();

        const { history } = this.props;
        const {id} = this.props.match.params;

        history.push(`/games/${id}`);
    }

    // helper to grab the id from the URL
    gameId() {
        return this.props.match.params.id;
    }

    // helper to get the game object.
    game() {
        const {games} = this.props;
        return games[this.gameId()];
    }

    render() {
        const { games  } = this.props;

        const id = this.gameId();

        // If we don't have data, fetch it and return
        if (!games || !games[id]) {
            // invalid state for step two of wizard (todo: more invalid states)
            fetchGame(id);
            return <div>Loading... </div>
        }

        const game = this.game();
        if (!game) {
            return <div>Error: No game</div>
        }

        const explanation = "Finally, add clues, the flesh and bones of your treasure hunt.  At least one is required "
                    + "to get started.  You can add more and edit existing clues and clue order at any time.";

        const endMessage = "Congratulations, you've finished drafting your hunt!\n\n"
                         + "The next page is the hunt overview -- where you can edit "
                         + "everything and publish when ready, or come back later.";

        return (
            <div className='editor'>

                <WizardHeader
                    game={game}
                    backOutText="Cancel"
                    backOutAction={this.openDeleteModal}
                    index={3}
                    stepName="Step 4:  Clues"
                    stepExplanation={explanation}
                />
                {/*<h2 className="top-padding">*/}
                {/*    Clues*/}
                {/*</h2>*/}

               <Link
                  to={`/games/${this.gameId()}/clues/edit`}
                  className="btn btn-default primary-link bottom-margin"
               >
                  Add Clue
               </Link>


               <AddCluesComponent
                    game={game}
                    isWizard={true}
                    editable={true}
                />

                <div className="clear-all bottom-margin"> </div>
                <button type="button" onClick={this.openDeleteModal} className="btn btn-danger right-margin">Cancel</button>
                <button type="button" onClick={this.onNext} className="btn btn-primary left-margin">Finish</button>

                <Modal
                    isOpen={this.state.deleteConfirmIsOpen}
                    onRequestClose={this.closeDeleteModal}
                    className="confirm-modal-content"
                    overlayClassName="my-modal-overlay"
                >
                    <ConfirmDelete
                        title="Abandon Hunt"
                        message="Are you sure you want to permanantly delete this new treasure hunt?"
                        confirmText="Yes"
                        onConfirm={this.delete}
                        closeModalCallback={this.closeDeleteModal}
                    />
                </Modal>

                <Modal
                    isOpen={this.state.huntCompletedIsOpen}
                    onRequestClose={this.moveOn}
                    className="confirm-modal-content"
                    overlayClassName="my-modal-overlay"
                >
                    <MessageDialog
                        title="Wizard Complete"
                        message={endMessage}
                        buttonText="OK"
                        callback={this.moveOn}
                    />
                </Modal>
            </div>
        )
    }
}

const authCondition = (authUser) => !!authUser;

const mapStateToProps = (state) => ({
    games: state.games
});

export default compose(
    withAuthorization(authCondition),
    connect(mapStateToProps, { fetchGame, deleteGame } ),
    withRouter
)(WizardClues);



// WEBPACK FOOTER //
// ./src/components/huntwizard/WizardClues.js